import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import {encrypt} from "../../helpers/CryptoJs";
import { withRouter } from "react-router-dom";
import AlbumHeader from "./AlbumHeader";
import AlbumBody from "./AlbumBody";
import AlbumEdit from "./AlbumBody/edit";
import {fetchAlbumDetails} from "./../../actions/mediaAction"

import $ from "jquery";
import "./album.css";


class AlbumContainer extends Component {
    constructor(props) {
      super(props);
      this.state = {
        albumHeader   : {},
        albumMedia    : {},
        albumReaction : {}, 
        albumId       : this.props.urlId,
        afterEdit     : false,
        pagetoload    : (window.location.href).includes('album_edit') ? 'edit' : 'view' 
      };
      this.changeView = this.changeView.bind(this);
    }
    componentDidMount() {
     let param = {
        album_id : this.state.albumId
     }
     this.props.fetchAlbumDetails(param);
    }

    changeView(state,id){
      this.setState({
        pagetoload    : (state == 'edit') ? 'edit' : 'view' 
      });
      if(state == 'edit'){
        this.props.history.push(`/album_edit/${encrypt(id)}`);
      }else{
        this.props.history.push(`/album/${encrypt(id)}`);
      }

      let param = {
        album_id : this.state.albumId
      }
      this.props.fetchAlbumDetails(param);
      
    }
   
    UNSAFE_componentWillReceiveProps(nextProps,prevProps,prevState){
      if(this.props.albumDetails != nextProps.albumDetails){
          this.setState({
            albumHeader   : nextProps.albumDetails.post_user,
            albumMedia    : nextProps.albumDetails.id,
            albumReaction : nextProps.albumDetails.album_reaction, 
          })
      }else{
        if(this.props.editAlbum != nextProps.editAlbum){
         let param = {
            album_id : this.state.albumId
          }
          this.props.fetchAlbumDetails(param);
        }
      }    
    }
    render() {
    /*content_block*/
    return (
      <div>
        <div className="container"> 
          <div className="col-lg-12">
            <AlbumHeader albumHeader={this.state.albumHeader}/> 
          </div>
        </div>
        <div className="container"> 
            
            { (this.state.pagetoload == 'view')? 
              <AlbumBody albumMedia={this.state.albumMedia} albumReaction={this.state.albumReaction} albumId={this.state.albumId} changeView={this.changeView}/> 
              : <AlbumEdit albumMedia={this.state.albumMedia} albumReaction={this.state.albumReaction} albumId={this.state.albumId} changeView={this.changeView}/> 
            }
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    albumDetails : state.albumdetails.albumDetails,
    editAlbum    : state.createalbum.newAlbum 
  }
}
const mapDispatchToProps = dispatch => {
  return {
    fetchAlbumDetails : bindActionCreators(fetchAlbumDetails, dispatch),
   
  }
}
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AlbumContainer));

